import { EkidenClient } from "@ekidenfi/ts-sdk";

import { EKIDEN_API_URL, EKIDEN_PRIVATE_WS_URL, EKIDEN_WS_URL } from "@constants";

let client: EkidenClient | undefined;
let vaultContractAddress = "";
let isConfigReady = false;
let currentToken: string | null = null;

const isMockMode = import.meta.env.VITE_ENABLE_MOCKS === "true";

export const setVaultContract = (address: string) => {
  vaultContractAddress = address;
};

export const getVaultContract = () => vaultContractAddress;

export const setConfigReady = (ready: boolean) => {
  isConfigReady = ready;
};

/**
 * Persists the current auth token at the module level.
 * Applied automatically to every newly created client so the token
 * is never lost when the client is re-created after a config reset.
 */
export const setCurrentToken = (token: string | null): void => {
  currentToken = token;
  if (client && token != null) {
    client.setToken(token);
  }
};

export const getEkidenSdkClient = (): EkidenClient => {
  if (!client || (!client.privateStream && isConfigReady)) {
    client = new EkidenClient({
      baseURL: EKIDEN_API_URL,
      wsURL: isConfigReady ? EKIDEN_WS_URL : undefined,
      privateWSURL: isConfigReady ? EKIDEN_PRIVATE_WS_URL : undefined,
      apiPrefix: "",
      contractAddress: vaultContractAddress,
    });
    if (currentToken) {
      client.setToken(currentToken);
    }
  }
  return client;
};

export const resetEkidenSdkClient = (): void => {
  if (client) {
    client.publicStream?.close();
    client.privateStream?.close();
    client = undefined;
  }
};

export { isMockMode };
